<template>
    <v-select 
    v-model="index"
    :items="options"
    item-text="name"
    :label="labelName"
    :rules="checkRules"
    clearable
    >
    </v-select>
</template>
<script>

export default {
    name: "CitySelect",
    props: ["value", "options", "labelName", "checkRules"],
    computed: {
        index: {
            get() {
                return this.value
            },
            set(val){
                //input不能改, 這裡的input，對應到@input事件
                this.$emit('input', val)
            }
        }
    },
    setup() {
        
    },
}
</script>
